import { Outlet } from 'react-router-dom';

import MandatoryAuthProvider from '@/components/AuthGate';
import Header from '@/components/Header';
import './style.css';

const Layout = () => {
  return (
    <MandatoryAuthProvider>
      <div className='layout'>
        <Header />
        <main className='layout__main'>
          <Outlet />
        </main>
      </div>
    </MandatoryAuthProvider>
  );
};

export default Layout;
